<template>
  <div>
    <!-- 作业设置 -->
    <el-dialog
      title="作业设置"
      :visible.sync="settingVisible"
      width="50%"
      center>
      <div>
        <el-form size="small" label-width="140px">
          <el-form-item label="作业设置">
            <el-radio-group v-model="collectSetting.type">
              <el-radio label="msg" checked>短信</el-radio>
              <el-radio label="v&m">短信加语音</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="作业天数">
            <el-input-number :min="1" :max="30" value="1" v-model="collectSetting.planDays"/> 天，至 <el-input :disabled='true' style="width: 30%;"/>日
          </el-form-item>
          <el-form-item label="最高减免">
            <el-input-number :min="0" :max="100" value="0" v-model="collectSetting.planDiscount" placeholder="最大为100"/>%
          </el-form-item>
          <el-form-item label="作业对象">
            <el-checkbox-group v-model="collectSetting.sendObject">
              <el-checkbox label="1" disabled checked>本人</el-checkbox>
              <el-checkbox label="2">直系</el-checkbox>
              <el-checkbox label="3">非直系</el-checkbox>
              <el-checkbox label="4">失联修复</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settingVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updatePlan();" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!-- 申请还款 -->
    <el-dialog
      title="申请还款"
      :visible.sync="applyVisible"
      width="70%"
      center>
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="还款金额*">
                <el-input-number placeholder="请输入还款金额" style="width: 100%;" :min="0.01" v-model="paymentReq.repayAmount" :precision="2"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="减免金额*">
                <el-input-number v-model="paymentReq.remitAmount" placeholder="请输入减免金额" style="width: 100%;" :min="0" :precision="2"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="还款人信息*">
                <el-select v-model="paymentReq.contactId" style="width: 100%;" placeholder="请选择还款人信息">
                  <el-option
                    v-for="item in allContactList"
                    :key="item.contactId"
                    :label="item.name"
                    :value="item.contactId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="还款人身份证号">
                <el-input v-model="paymentReq.payIdNo" placeholder="请输入还款人身份证号" style="width: 100%;"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item label="还款人卡号">
                <el-input v-model="paymentReq.payCard" placeholder="请输入还款人卡号" style="width: 100%;"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="还款人手机号">
                <el-input v-model="paymentReq.payMobile" placeholder="请输入还款人手机号" style="width: 100%;"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="还款方式*">
                <el-select v-model="paymentReq.repayType" style="width: 100%;" placeholder="请选择还款方式">
                  <el-option
                    v-for="item in payOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="还款时间*">
                <el-date-picker type="datetime" v-model="paymentReq.repayTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" placeholder="请选择还款时间"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="上传凭证" >
                <el-upload class="upload-demo" :on-change="fileChanged" multiple :limit="1" ref="upload" action='#' accept="image/jpeg,image/gif,image/png,image/bmp" :auto-upload="false">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="applyVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addPay" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加联系人 -->
    <el-dialog
      title="添加联系人"
      :visible.sync="addContactVisible"
      width="60%"
      center>
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input placeholder="请输入姓名" v-model="contactBody.name"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话">
                <el-input placeholder="请输入电话" v-model="contactBody.detail"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="关系">
                <el-select v-model="contactBody.type" style="width: 100%;" placeholder="请选择关系类型">
                  <el-option
                    v-for="item in contactOper.contactTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item>
                <el-input type="textarea" resize="none" :rows="7" placeholder="请输入备注" v-model="contactBody.remark"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addContactVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addContact();" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加评价 -->
    <el-dialog
      title="添加评价"
      :visible.sync="commentVisible"
      width="30%"
      center>
      <div>
        <el-form size="small">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="联系人">
                <el-select v-model="addContentReq.contactId" style="width: 100%;" placeholder="请选择联系人">
                  <el-option
                    v-for="item in allContactList"
                    :key="item.contactId"
                    :label="item.name"
                    :value="item.contactId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" label="评价内容">
              <el-form-item>
                <el-input type="textarea" resize="none" :rows="7" v-model="addContentReq.content" placeholder="请输入评价内容"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="commentVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addContent" size="small">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const Base64 = require('js-base64').Base64;

export default {
  props: [
    'updateVisible',
    'contactId',
    'contacts'
  ],
  data() {
    return {
      settingVisible: false,
      applyVisible: false,
      addContactVisible: false,
      commentVisible: false,
      stopVisible: false,
      continuetVisible: false,
      currentContactId: null,
      allContactList: [],
      collectSetting: {
        type: 'msg',
        planDays: null,
        planDiscount: null,
        sendObject: []
      },
      paymentReq: {
        contactId: null,
        repayAmount: null,
        remitAmount: 0,
        repayType: null,
        repayTime: null,
        payIdNo: null,
        payCard: null,
        payMobile: null,
        fileList: null
      },
      contactOper: {
        contactTypeList: [
          {
            'label': '直系电话',
            'value': 'zhixidianhua'
          },
          {
            'label': '非直系电话',
            'value': 'feizhixidianhua'
          },
          {
            'label': '本人电话',
            'value': 'benrendianhua'
          }
        ]
      },
      contactBody: {
        name: null,
        type: null,
        detail: null,
        remark: null
      },
      addContentReq: {
        contactId: null,
        content: null
      },
      payOptions: [
        {
          'value': 'remittance',
          'label': '汇款'
        }, {
          'value': 'recharge',
          'label': '充值'
        }, {
          'value': 'deduction',
          'label': '划扣'
        }
      ],
      count: null
    };
  },
  watch: {
    updateVisible(val) {
      if (val === 'settingVisible') {
        this.settingVisible = true;
      } else if (val === 'applyVisible') {
        this.getContactList();
        this.applyVisible = true;
      } else if (val === 'addContactVisible') {
        this.addContactVisible = true;
      } else if (val === 'commentVisible') {
        this.getContactList();
        this.commentVisible = true;
      } else if (val === 'stopVisible') {
        console.warn('暂停作业');
        this.updateUrgeStatus(-1);
        this.stopVisible = true;
      } else if (val === 'continuetVisible') {
        console.warn('继续作业');
        this.updateUrgeStatus(1);
        this.continuetVisible = true;
      }
    },
    settingVisible: 'changeUpdateVisible',
    applyVisible: 'changeUpdateVisible',
    addContactVisible: 'changeUpdateVisible',
    commentVisible: 'changeUpdateVisible',
    stopVisible: 'changeUpdateVisible',
    continuetVisible: 'changeUpdateVisible',
    contactId(val) {
      this.currentContactId = val;
    }
  },
  methods: {
    getContactList() {
      const all = [].concat(this.contacts.benrendianhua, this.contacts.lianxiren, this.contacts.repair);
      this.allContactList = [];
      all.forEach((item) => {
        const temp = {};
        temp.contactId = item.contactId;
        temp.name = `${item.contactName}(${item.typeName.replace('电话', '')})`;
        this.allContactList.push(temp);
      });
    },
    updatePlan() {
      const caseId = Base64.decode(this.$route.params.id).trim();
      this.collectSetting.caseId = caseId;
      const uri = '/robotCase/caseDetailUpdatePlan';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: this.collectSetting
      }).then(
        this.settingVisible = false
      );
    },
    addContact() {
      const caseId = Base64.decode(this.$route.params.id).trim();
      this.contactBody.caseId = caseId;
      const uri = '/contact/addContact';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: this.contactBody
      }).then(
        this.addContactVisible = false
      );
    },
    addContent() {
      const uri = '/contact/addContent';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: this.addContentReq
      }).then(
        this.commentVisible = false
      );
    },
    addPay() {
      const uri = '/caseDetail/addPayment';
      const formData = new FormData();
      if (this.paymentReq.contactId) formData.append('contactId', this.paymentReq.contactId);
      if (this.paymentReq.repayAmount) formData.append('repayAmount', this.paymentReq.repayAmount);
      formData.append('remitAmount', this.paymentReq.remitAmount);
      if (this.paymentReq.repayType) formData.append('repayType', this.paymentReq.repayType);
      if (this.paymentReq.repayTime) formData.append('repayTime', this.paymentReq.repayTime);
      if (this.paymentReq.payIdNo) formData.append('payIdNo', this.paymentReq.payIdNo);
      if (this.paymentReq.payCard) formData.append('payCard', this.paymentReq.payCard);
      if (this.paymentReq.payMobile) formData.append('payMobile', this.paymentReq.payMobile);
      if (this.paymentReq.fileList) {
        formData.append('file', this.paymentReq.fileList[0].raw);
      }
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'multipart/form-data',
        data: formData
      }).then(
        this.applyVisible = false
      );
    },
    fileChanged(file, fileList) {
      this.paymentReq.fileList = fileList;
      console.warn(this.paymentReq.fileList);
    },
    changeUpdateVisible() {
      this.$emit('updateVisible', null);
    },
    // 暂停/继续作业
    updateUrgeStatus(status) {
      const caseId = Base64.decode(this.$route.params.id).trim();
      if (status === -1) {
        this.count = '暂停作业';
      } else {
        this.count = '继续作业';
      }
      this.$confirm(`确定${this.count}吗？`, '提示', {
        confirmButtonText: `${this.count}`,
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loadings = this.$partLoading();
        const queryDatas = {};
        queryDatas.urgeStatus = status;
        queryDatas.caseId = caseId;
        this.$ajax({
          url: '/caseDetail/updateUrgeStatus',
          params: queryDatas
        }).then(() => {
          loadings.close();
        }).catch((error) => {
          loadings.close();
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: `取消${this.count}`
        });
        this.count = null;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/case/detailOperate.vue